import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useFetch, useApiClient } from '@marageti/z4-lib';
import { Alert, AlertTitle, Box } from '@mui/material';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import ConversationView from './conversations';

const MessagesContainer = () => {
  const { tripMatchId } = useParams();
  const apiClient = useApiClient();
  const navigate = useNavigate();
  const { data: tripMatch, error } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], true);
  if (error?.code === 401) navigate('/logout');

  if (error) {
    return (
      <Box sx={{ my: 3 }}>
        <Alert severity="error" sx={{ py: 2 }}>
          <AlertTitle>An error occurred</AlertTitle>
          {`Code: ${error.code}: ${error.message}`}
          {error.id && `ID: ${error.id}`}
        </Alert>
      </Box>
    );
  }

  return (
    <ConversationView
      conversationTitle={tripMatch?.partnerName}
      conversationId={tripMatch?.travelerToPartnerId}
      tripMatch={tripMatch}
    />
  );
};

export default MessagesContainer;
